import { render, staticRenderFns } from "./propertyTenureForm.vue?vue&type=template&id=23dd5ac6&%23default=true&"
import script from "./propertyTenureForm.vue?vue&type=script&lang=js&"
export * from "./propertyTenureForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports